export default __webpack_public_path__ + "static/media/handprint-26-27-page.67d6b9a8.png";